// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./link.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._14XHlEOPx{position:relative;padding:5px 15px 5px 50px;margin:4px 0;font-size:14px;color:var(--primary-text);line-height:20px;-ms-high-contrast-adjust:none}._14XHlEOPx:hover{color:var(--primary-text);background-color:var(--ui-subtle-hover)}@media (max-width: 767px){html[data-supports-mobile=true] ._14XHlEOPx{height:40px;line-height:30px}}._3zQjiAlXx{font-weight:bold;background-color:var(--ui-subtle-active)}._3zQjiAlXx:hover{background-color:var(--ui-subtle-active-hover)}._3zQjiAlXx::before{top:5px;bottom:5px}@media (max-width: 767px){html[data-supports-mobile=true] ._3zQjiAlXx::before{top:8px;bottom:8px}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"child-link": "_14XHlEOPx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["link"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["transition-opacity"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + "",
	"childLink": "_14XHlEOPx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["link"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["transition-opacity"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + "",
	"active": "_3zQjiAlXx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["active"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["with-active-indicator"] + ""
};
module.exports = exports;
